import "./Term.css";

const headerStyle = {
  color: "#1A1B1F",
  fontFamily: "Times New Roman, serif",
  fontStyle: "normal",
  fontWeight: "bold",
  textDecoration: "none",
  fontSize: "13.5pt",
};

const paragraphStyle = {
  color: "#1A1B1F",
  fontFamily: "Times New Roman, serif",
  fontStyle: "normal",
  fontWeight: "normal",
  textDecoration: "none",
  fontSize: "12pt",
  margin: "0pt",
};

const TermsPro = () => {
  return (
    <>
      <h3 className="privacy-policy-title text-[18px]">MentalFit "Engage a Pro" Terms and Conditions</h3>
      {/* ---------- Emergency Notice ---------- */}
      <p
        className="s1"
        style={{
          ...paragraphStyle,
          paddingTop: "3pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        IN THE EVENT OF A MEDICAL EMERGENCY, CALL YOUR LOCAL EMERGENCY NUMBER
        IMMEDIATELY. DO NOT DISREGARD, AVOID, OR DELAY SEEKING MEDICAL ADVICE
        FROM A QUALIFIED HEALTHCARE PROVIDER BECAUSE OF INFORMATION YOU HAVE
        READ ON THE MENTALFIT WEBSITE, MOBILE APPLICATION, OR OBTAINED THROUGH
        OUR SERVICES. THE PLATFORM, INCLUDING THE ENGAGE A PRO FEATURE, DOES NOT
        PROVIDE MEDICAL DIAGNOSIS OR EMERGENCY CARE SERVICES, AND WE DO NOT
        MONITOR THE PLATFORM, WEBSITE, MOBILE APPLICATION, OR ANY COMMUNICATIONS
        FOR MEDICAL EMERGENCY PURPOSES. ANY INFORMATION PROVIDED THROUGH THE
        PLATFORM IS FOR GENERAL WELLNESS AND INFORMATIONAL PURPOSES ONLY AND IS
        NOT A SUBSTITUTE FOR PROFESSIONAL MEDICAL ADVICE, DIAGNOSIS, OR
        TREATMENT.
      </p>

      <p style={{ ...paragraphStyle, textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>

      {/* ---------- Independent Third-Party Provider Status ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "1pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Independent Third-Party Provider Status
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "1pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        You acknowledge and agree that you are an independent third-party
        provider, and nothing in this Agreement shall be construed to create an
        employment, agency, partnership, or joint venture relationship between
        you and MentalFit. You are not entitled to any benefits provided by
        MentalFit to its employees or affiliates. You are solely responsible for
        determining the means and methods of performing your services and are
        not subject to MentalFit’s direction or control, except as explicitly
        stated in this Agreement.
      </p>

      {/* ---------- License Grant to Services ---------- */}
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
          display: "inline",
        }}
      >
        <strong>4. License Grant to Services.</strong> Subject to the terms and
        conditions of these Terms of Use and your compliance therewith, Company
        hereby grants to you a limited, personal, non-exclusive,
        non-transferable and revocable license to use the Services in the manner
        contemplated by these Terms of Use and in accordance with the
        Documentation (as defined below), solely for your personal use. Users
        shall have no right to sub-license or resell the Services or any
        component thereof. If applicable, Company may set certain additional
        limits and restrictions on use for your free trial version of the
        Services at any time, and may terminate your license to use the free
        trial version at any time, at Company’s discretion.
      </p>

      {/* ---------- Lifetime Access Plans ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        4a. Lifetime Access Plans
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Certain MentalFit offerings may be marketed or sold as “Lifetime Access”
        plans. For the avoidance of doubt, “Lifetime Access” refers exclusively
        to ongoing access to the specific features, functionality, and services
        that were included in the plan tier at the time of purchase. Lifetime
        Access does not entitle the user to (i) future upgrades, new products,
        or premium features introduced after the date of purchase; (ii)
        third-party integrations, partner services, or expanded functionality
        added at a later time; or (iii) access to successor platforms, mobile
        applications, or product versions that are materially distinct from the
        original service purchased. Lifetime Access shall remain valid for the
        operational lifetime of the MentalFit platform or until such time as
        MentalFit ceases to offer or support the product for technical,
        business, or legal reasons, at its sole discretion. In the event of
        discontinuation, MentalFit will make commercially reasonable efforts to
        maintain user access to core functionality for a reasonable transition
        period. MentalFit expressly reserves the right to modify, replace, or
        retire specific features or services at any time, provided that such
        actions do not materially deprive Lifetime Access holders of the core
        features originally included at the time of their purchase.
      </p>

      {/* ---------- Pricing and Fee Adjustments ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        4b. Pricing and Fee Adjustments
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        MentalFit reserves the right, at its sole and absolute discretion, to
        modify, increase, or otherwise adjust the pricing, fees, or billing
        structures applicable to any product, plan, or service at any time and
        for any reason, with or without prior notice. Any such pricing
        modifications will apply prospectively and shall not affect payments
        already completed or billing cycles already in progress prior to the
        effective date of the change. Continued use of the MentalFit platform
        following any pricing modification constitutes acceptance of the new
        pricing. MentalFit further reserves the right to introduce new services,
        tiers, or functionality that may be subject to separate or additional
        fees, and users acknowledge that access to such new services shall not
        be included under previously purchased plans or licenses unless
        explicitly stated by MentalFit in writing.
      </p>

      {/* ---------- Promo Codes and Discounts ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        4C. Promo Codes and Discounts
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        From time to time, MentalFit, Inc. (“MentalFit,” “we,” “our,” or “us”)
        may offer promotional offers, discount codes, or affiliate codes (“Promo
        Codes”) that provide price reductions or other benefits on subscription
        plans or one-time purchases. Use of any Promo Code constitutes
        acceptance of these Promo Code Terms in addition to the MentalFit Terms
        of Use and Privacy Policy.
      </p>
      <p
        style={{
          ...headerStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        A. Eligibility and Redemption.
      </p>
      <ul style={{ paddingLeft: "40px", margin: 0 }}>
        <li className="custom-li">
          Promo Codes may only be redeemed by eligible new users, as specified
          in the promotion details.
        </li>
        <li className="custom-li">
          Each Promo Code may be used once per user account unless otherwise
          expressly stated.
        </li>
        <li className="custom-li">
          Promo Codes must be entered at the time of purchase; they cannot be
          applied retroactively to an existing or prior subscription.
        </li>
        <li className="custom-li">
          Promo Codes are non-transferable, non-redeemable for cash, and may not
          be combined with other offers unless explicitly allowed by MentalFit.
        </li>
        <li className="custom-li">
          Unauthorized resale, distribution, or sharing of Promo Codes is
          strictly prohibited.
        </li>
      </ul>

      <p
        style={{
          ...headerStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        B. Discount Amount and Duration.
      </p>
      <ul style={{ paddingLeft: "40px", margin: 0 }}>
        <li className="custom-li">
          Each Promo Code will specify the applicable discount percentage or
          amount, which may vary by promotion or product offering.
        </li>
        <li className="custom-li">
          Discounts apply only to the subscription plan or purchase type
          identified in the promotional offer.
        </li>
        <li className="custom-li">
          Any promotional discount remains in effect only for as long as the
          subscription remains active and in good standing.
        </li>
        <li className="custom-li">
          If a subscription is canceled, expires, or otherwise lapses, the Promo
          Code and any associated discount automatically terminate.
        </li>
        <li className="custom-li">
          Lifetime plans receive a one-time discount applied at checkout only.
        </li>
        <li className="custom-li">
          For recurring subscriptions (e.g., monthly or annual), the discount
          will continue for the stated promotional period (if any) or, if
          unspecified, until MentalFit modifies or withdraws the offer.
        </li>
      </ul>

      <p
        style={{
          ...headerStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        C. Modification, Suspension, and Termination.
      </p>
      <ul style={{ paddingLeft: "40px", margin: 0 }}>
        <li className="custom-li">
          MentalFit reserves the right, at any time and in its sole discretion,
          to modify, suspend, or terminate any Promo Code, discount program, or
          promotional offer, with or without prior notice.
        </li>
        <li className="custom-li">
          If a promotional offer is discontinued, existing subscribers will
          receive at least 30 days’ notice before any pricing changes take
          effect.
        </li>
        <li className="custom-li">
          MentalFit may revoke or cancel a Promo Code and terminate associated
          discounts in the event of fraud, abuse, misuse, or violation of these
          Terms or any applicable law.
        </li>
      </ul>

      <p
        style={{
          ...headerStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        D. Refunds and Chargebacks.
      </p>
      <ul style={{ paddingLeft: "40px", margin: 0 }}>
        <li className="custom-li">
          Refunds for purchases made using a Promo Code are calculated based on
          the discounted price actually paid by the user.
        </li>
        <li className="custom-li">
          If a refund or chargeback is issued, the Promo Code is deemed fully
          used and cannot be reused or reinstated.
        </li>
        <li className="custom-li">
          MentalFit reserves the right to deduct any refunded amount from future
          promotional eligibility or to revoke future Promo Code use if abuse is
          detected.
        </li>
      </ul>

      <p
        style={{
          ...headerStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        E. No Cash Value; Limitations of Liability.
      </p>
      <ul style={{ paddingLeft: "40px", margin: 0 }}>
        <li className="custom-li">
          Promo Codes hold no cash or property value.
        </li>
        <li className="custom-li">
          MentalFit is not responsible for lost, stolen, expired, or
          unauthorized Promo Codes.
        </li>
        <li className="custom-li">
          To the fullest extent permitted by law, MentalFit’s total liability
          for any claim relating to a Promo Code shall not exceed the actual
          discount value applied at the time of purchase.
        </li>
      </ul>

      <p
        style={{
          ...headerStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        F. Interpretation and Enforcement.
      </p>
      <ul style={{ paddingLeft: "40px", margin: 0 }}>
        <li className="custom-li">
          MentalFit reserves the exclusive right to determine user eligibility
          and interpret or enforce these Promo Code Terms.
        </li>
        <li className="custom-li">
          All decisions by MentalFit are final and binding.
        </li>
        <li className="custom-li">
          Promo Codes are void where prohibited by law.
        </li>
        <li className="custom-li">
          These Promo Code Terms are governed by the same laws and
          dispute-resolution procedures described in the main MentalFit Terms of
          Use.
        </li>
      </ul>

      {/* ---------- No Endorsement or Vetting ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        No Endorsement or Vetting
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        MentalFit does not endorse, verify, or guarantee any Provider’s
        qualifications, licensing, credentials, background, services, or
        compliance with law. Providers are solely responsible for ensuring the
        legality and professionalism of their services and representations.
      </p>

      {/* ---------- Provider Responsibilities ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Provider Responsibilities
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        As a Provider, you agree to:
      </p>
      <ul>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "41pt",
            textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          - Maintain all licenses, certifications, and professional standards
          required under the laws of the State of Colorado and any jurisdiction
          in which you practice.
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "41pt",
            textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          - Be solely responsible for the nature, quality, legality, safety, and
          delivery of any services you provide.
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "41pt",
            textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          - Set your own fees and handle all billing, taxes, and client
          communication unless otherwise agreed in writing.
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "41pt",
            textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          - Provide services in accordance with applicable Colorado state and
          federal law, including any professional codes of conduct and
          scope-of-practice limitations.
        </li>
      </ul>

      {/* ---------- MentalFit’s Role ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        MentalFit’s Role
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        MentalFit does not provide medical, therapeutic, or wellness services
        and does not supervise or direct or endorse your work and/or product.
        You acknowledge that:
      </p>
      <ul>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "41pt",
            textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          - You are not acting on behalf of MentalFit when interacting with
          clients;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "41pt",
            textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          - MentalFit is merely a neutral technology platform enabling
          connection between users and Providers;
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "41pt",
            textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          - MentalFit shall not be liable for any claims, disputes, injuries, or
          outcomes related to your services.
        </li>
      </ul>

      {/* ---------- Privacy and Data Compliance ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Privacy and Data Compliance
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        You must comply with all applicable privacy and confidentiality
        obligations, including HIPAA, where applicable. MentalFit does not
        access or monitor Provider-client communications and disclaims all
        responsibility for any data exchanged between parties. You agree not to
        use or disclose client information in any way that violates privacy laws
        or professional standards.
      </p>

      {/* ---------- Communications and Email Preferences ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Communications and Email Preferences
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        When you create a MentalFit account, we will send you certain email
        communications that are necessary to provide and support our services.
        These transactional or service-related emails may include, without
        limitation, welcome messages, appointment confirmations, reminders,
        password resets, account notifications, and other messages directly
        related to your use of MentalFit.
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        We may also send occasional promotional or informational emails about
        new features, wellness content, events, or services that we believe may
        be relevant to you. You can opt out of receiving these non-essential
        promotional emails at any time by following the unsubscribe instructions
        in the email or by adjusting your preferences in your account settings.
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Please note that transactional or service-related emails are an
        essential part of your MentalFit experience and you cannot opt out of
        receiving them without deactivating your account. We will not include
        protected health information (PHI) in any email communications.
      </p>

      {/* ---------- Indemnification ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Indemnification
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        You agree to indemnify, defend, and hold harmless MentalFit, its
        officers, directors, employees, agents, licensors, providers, and
        affiliates from and against any and all claims, actions, damages,
        losses, liabilities, judgments, settlements, costs, or expenses
        (including reasonable attorneys’ fees) arising out of or relating to:
      </p>
      <ul style={{ paddingLeft: "40px", margin: 0 }}>
        <li className="custom-li">Your use of the Platform;</li>
        <li className="custom-li">
          Any services, advice, or content you provide to users;
        </li>
        <li className="custom-li">
          Your own payment collection, refund policy, cancellation policy, or
          any disputes with users related to such transactions;
        </li>
        <li className="custom-li">
          Any breach of this Agreement, applicable law, or regulations.
        </li>
      </ul>

      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        This indemnity shall survive termination of your participation in Engage
        a Pro and/or your use of the Platform.
      </p>

      {/* ---------- Limitation of Liability ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Limitation of Liability
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        TO THE MAXIMUM EXTENT PERMITTED BY COLORADO LAW, MENTALFIT SHALL NOT BE
        LIABLE TO YOU OR ANY THIRD PARTY FOR ANY INDIRECT, INCIDENTAL,
        CONSEQUENTIAL, SPECIAL, EXEMPLARY, OR PUNITIVE DAMAGES, OR FOR ANY LOSS
        OF PROFITS, REVENUE, DATA, OR GOODWILL, WHETHER ARISING IN CONTRACT,
        TORT, OR OTHERWISE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
        MENTALFIT’S TOTAL CUMULATIVE LIABILITY FOR ANY CLAIMS ARISING OUT OF OR
        RELATING TO THIS AGREEMENT SHALL NOT EXCEED THE GREATER OF (A) $100 OR
        (B) THE TOTAL AMOUNTS PAID BY YOU TO MENTALFIT IN THE 12 MONTHS
        PRECEDING THE CLAIM.
      </p>

      {/* ---------- Termination ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Termination
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        MentalFit reserves the right to suspend or terminate your access to
        Engage a Pro at any time, with or without cause or notice. You may also
        terminate your participation at any time. Termination does not relieve
        you of any obligations incurred prior to the effective date of
        termination, including your indemnification obligations.
      </p>

      {/* ---------- Modifications ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Modifications
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        MentalFit may modify these Terms at any time. Updated terms will be
        posted on the Platform and effective immediately. Your continued use of
        Engage a Pro after any modification constitutes your acceptance of the
        new terms.
      </p>

      {/* ---------- Governing Law and Dispute Resolution ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Governing Law and Dispute Resolution
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        This Agreement shall be governed by and construed in accordance with the
        laws of the State of Colorado, without regard to its conflict of laws
        principles. Any disputes arising under or related to this Agreement
        shall be subject to the exclusive jurisdiction of the state and federal
        courts located in Denver County, Colorado, and you hereby submit to
        their jurisdiction and waive any objection to venue.
      </p>

      {/* ---------- Entire Agreement ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Entire Agreement
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        This Agreement constitutes the entire understanding between you and
        MentalFit regarding your participation in Engage a Pro and supersedes
        all prior or contemporaneous communications and agreements, whether oral
        or written.
      </p>

      {/* ---------- Insurance Requirement ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Insurance Requirement
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Provider shall, at their own expense, maintain appropriate professional
        liability insurance (e.g., malpractice, errors and omissions) with
        coverage limits customary for their industry and jurisdiction. Provider
        agrees to furnish proof of such insurance to MentalFit upon request.
      </p>

      {/* ---------- Background Check Consent ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Background Check Consent
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        MentalFit reserves the right to require background checks for Providers
        in certain service categories. By participating in Engage a Pro, you
        consent to such screening, if requested, and agree to provide necessary
        authorizations.
      </p>

      {/* ---------- Prohibited Conduct ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Prohibited Conduct
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Provider agrees not to engage in any unlawful, harmful, harassing,
        discriminatory, or misleading behavior on the Platform. MentalFit
        reserves the right to remove any Provider who violates this provision,
        in its sole discretion, without liability.
      </p>

      {/* ---------- AI Moderation Disclaimer ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        AI Moderation Disclaimer
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        The Services may employ automated content monitoring, filtering, and
        moderation technologies, including without limitation artificial
        intelligence and machine learning systems (collectively, the “Moderation
        System”), for the purpose of identifying, restricting, or removing
        content that MentalFit, in its sole discretion, deems to be in violation
        of these Terms or otherwise inappropriate.
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        You acknowledge and agree that:
      </p>
      <ol>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "41pt",
            textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          <b>1. No Warranty:</b> The Moderation System is inherently limited and
          may fail to identify, restrict, or remove content that violates these
          Terms, or may erroneously identify, restrict, or remove content that
          does not. MentalFit makes no representation, warranty, or guarantee
          regarding the accuracy, reliability, or effectiveness of the
          Moderation System.
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "41pt",
            textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          <b>2. Limitation of Liability:</b> To the fullest extent permitted by
          law, MentalFit shall not be liable for any claims, losses, damages,
          liabilities, costs, or expenses of any kind, whether direct, indirect,
          incidental, consequential, or otherwise, arising out of or relating to
          (a) the failure of the Moderation System to prevent access to
          prohibited content, (b) the erroneous restriction or removal of
          permissible content, or (c) any reliance by you or any third party on
          the operation of the Moderation System.
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "41pt",
            textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          <b>3. User Responsibility:</b> You remain solely and exclusively
          responsible for any content you create, transmit, publish, or
          otherwise make available through the Services, irrespective of the
          functioning or non-functioning of the Moderation System.
        </li>
        <li
          style={{
            ...paragraphStyle,
            paddingTop: "6pt",
            paddingLeft: "41pt",
            textIndent: "-18pt",
            textAlign: "left",
          }}
        >
          <b>4. Reservation of Rights:</b> MentalFit retains the right, but not
          the obligation, to monitor, review, edit, restrict, or remove any
          content, in whole or in part, at any time and for any reason, with or
          without notice, and without liability of any kind.
        </li>
      </ol>

      {/* ---------- No Use of MentalFit Branding ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        No Use of MentalFit Branding
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Provider may not use MentalFit’s name, logo, trademarks, or branding in
        any advertising, representation, or communication without prior written
        consent from MentalFit.
      </p>

      {/* ---------- Taxes and Financial Responsibility ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Taxes and Financial Responsibility
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Provider acknowledges and agrees that they are solely responsible for
        all federal, state, and local taxes, fees, and other assessments arising
        from compensation received through Engage a Pro.
      </p>

      {/* ---------- Severability ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Severability
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        If any provision of this Agreement is found to be invalid or
        unenforceable under applicable law, the remainder of the Agreement shall
        remain in full force and effect.
      </p>

      {/* ---------- Survival ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Survival
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        The provisions relating to Limitation of Liability, Indemnification,
        Confidentiality, and Governing Law shall survive the termination or
        expiration of this Agreement.
      </p>

      {/* ---------- Platform Neutrality and Payment Disclaimer ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Platform Neutrality and Payment Disclaimer
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        MentalFit serves solely as a discovery and connection platform. All
        services are provided directly by independent third-party providers to
        users, and all payments are transacted independently between those
        parties. MentalFit does not collect, hold, or distribute funds related
        to these services.
      </p>

      {/* ---------- Clarification of Role and Responsibility ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Clarification of Role and Responsibility
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        MentalFit is not a party to any agreement between providers and users.
        All agreements, scheduling, service delivery, and payments are handled
        independently by the provider and the user. MentalFit does not control,
        influence, or participate in the terms, quality, or execution of any
        service agreement.
      </p>

      {/* ---------- Assignment ---------- */}
      <p
        style={{
          ...headerStyle,
          paddingTop: "12pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        Assignment
      </p>
      <p
        style={{
          ...paragraphStyle,
          paddingTop: "6pt",
          paddingLeft: "5pt",
          textIndent: "0pt",
          textAlign: "left",
        }}
      >
        We may assign or transfer our rights and obligations under these Terms,
        in whole or in part, to any affiliate, successor, or in connection with
        a merger, acquisition, corporate reorganization, or sale of assets,
        without notice to you and without your consent. You may not assign or
        transfer any of your rights or obligations under these Terms without our
        prior written consent, and any attempted assignment in violation of this
        provision shall be null and void. These Terms shall be binding upon and
        inure to the benefit of the parties and their respective successors and
        permitted assigns.
      </p>
    </>
  );
};

export default TermsPro;
